import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Constants } from "../constants/constants";
import { HttpClient } from "../authentication/httpClient";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";

@Injectable()
export class DepartmentService {

    constructor(private http: HttpClient) { }

	getDepartments(): Observable<Array<IDepartmentModel>> {
		return this.http.get(`${Constants.restUrl}Department/GetDepartments`, {}).map((res: Response) => res.json()).catch(this.handleError);
	}

    saveDepartment(department: IDepartmentModel) {
        return this.http.post(`${Constants.restUrl}Department/UpdateDepartment`, department).map((res: Response) => res.json()).catch(this.handleError);
    }

    addDepartment(department: IDepartmentModel) {
        return this.http.post(`${Constants.restUrl}Department/AddDepartment`, department).map((res: Response) => res.json()).catch(this.handleError);
    }

    getPendingDepartmentReqs(department: IDepartmentModel): Observable<number> {
        return this.http.get(`${Constants.restUrl}Department/GetPendingDepartmentReqs/${department.id}`).map((res: Response) => res.json()).catch(this.handleError);
    }

	private handleError(error: any): Observable<any> {
		console.error("An error occurred", error);
		return Observable.throw(error.message || error);
	}
}